export function convertAviaToMinPricesParameters(parameters) {
    return Object.assign(Object.assign({}, parameters), { segments: parameters.segments.map(segment => ({
            date: segment.date,
            departure: { iata: segment.departure.iata },
            arrival: { iata: segment.arrival.iata }
        })) });
}
